import React from 'react';
import { IconProps } from '../types';

const Pound = ({
  width = '22px',
  height = '22px',
  color = '#dededf'
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 490 490"
      strokeWidth="1px"
    >
      <path d="M245 0C109.5 0 0 109.5 0 245s109.5 245 245 245 245-109.5 245-245S380.5 0 245 0zM245 449.3c-112.6 0-204.3-91.7-204.3-204.3S132.4 40.7 245 40.7 449.3 132.4 449.3 245 357.6 449.3 245 449.3z" />
      <path d="M332.5 321.1c-5.3-8.1-16.3-10.7-24.2-5.2 -22.6 15.9-52.9 0.6-55.7-0.2 -10.4-2.7-23.8-2.2-36.8-0.4 1.9-4.3 3.5-8.7 5-13.4 4-12.6 6.1-25.4 6.3-37.5h37.2c9.7 0 17.5-7.8 17.5-17.5s-7.8-17.5-17.5-17.5h-42.6c0-0.1-0.1-0.3-0.1-0.4 -8.3-22.4-3.4-61.2 21-64.6 32.6-4.4 38.6 29.4 38.7 30.5 0.8 8.9 8.3 15.8 17.4 15.8 16.9 0 17.6-16.1 17.3-19.7l0 0c-0.2-1.6-8.6-65.2-73.5-61.6 -59.9 3.4-62.8 81-57.6 100h-12.5c-9.7 0-17.5 7.8-17.5 17.5 0 9.7 7.8 17.5 17.5 17.5h19.7c-0.7 26-13.8 54.7-29.1 64.5 -7.4 4.8-10.9 14.7-6.4 22.3 6.8 11.3 19.5 9.7 21.3 9 19.4-6.5 52.6-14.1 65.8-10.6 2.6 0.7 45.3 22.4 83.6-4.4C335.3 339.7 337.8 329.2 332.5 321.1z" />
    </svg>
  );
};

export default Pound;
